import type { Submission, SubmissionStatus } from "@/lib/api";
import { request } from "@/lib/api";

/**
 * The two endpoints only a client-simulated challenge has.
 *
 * A recording is uploaded and scored in the background, so the student polls for
 * the result. A server-simulated run is scored as its session ends and needs
 * neither call; its submission row is `done` from the moment it exists.
 */
export const legacyApi = {
  /** Upload an encrypted `.npy` recording. 202; poll `status` for the score. */
  submit: (challengeId: string, file: File, apiKey: string) => {
    const form = new FormData();
    form.append("file", file);
    return request<{ job_id: string; status: SubmissionStatus }>(
      `/submit/${challengeId}`,
      { method: "POST", body: form },
      { apiKey },
    );
  },

  status: (jobId: string, apiKey: string) =>
    request<Submission>(`/status/${jobId}`, {}, { apiKey }),
};
